import axios from "axios";
//getEmployeeBioData
import {
	DATA_LOADING,
	DATA_SAVING_FAILED,
	DATA_SAVING_SUCCESSED,
} from "./types";
export const loadBioData = (listdata) => (dispatch) => {
	try {
		dispatch({ type: DATA_LOADING });

		let formData = new FormData(); //formdata object
		console.log("loadNotifications data=", listdata);

		listdata.data.map((listdata) => {
			formData.append(listdata.name, listdata.value); //append the values with key, value pair
		});

		const token = localStorage.getItem("token");
		const config = {
			headers: {
				"x-auth-token": token,
				"content-type": "application/json",
			},
		};

		axios
			.post(listdata.url, formData, config)
			.then((response) => {
				dispatch({ type: DATA_SAVING_SUCCESSED, payload: response });

				console.log("loadNotifications=", response);
			})
			.catch((error) => {
				console.log(error);
				return dispatch({
					type: DATA_SAVING_FAILED,
					payload: error,
				});
			});
	} catch (e) {
		return dispatch({
			type: DATA_SAVING_FAILED,
			payload: "failed to save biodata",
		});
	}
};
